import { BUTTONS, TEXT, TITLE } from '../components/modals/universalModal'
import { giftMeModalContent } from '../constants/copyright-modals'
import { CUSTOMIZATION } from '../constants/shared/states/names'

export function buildGiftMeModal({ closeModal, setState }) {
  const { title, description, buttons } = giftMeModalContent

  const onButtonClick = () => {
    setState(CUSTOMIZATION)
    closeModal('all')
  }

  return {
    type: 'universalModal',
    props: {
      modalProps: {
        wrapper: { isFullPage: false },
        modifier: ['noFullNoScroll'],
      },
      components: [
        {
          list: [
            {
              type: TITLE,
              props: {
                modifier: 'padding-no',
                value: title,
              },
            },
            {
              type: TEXT,
              props: {
                value: description,
              },
            },
            {
              type: BUTTONS,
              props: {
                buttons: buttons?.map((button) => {
                  const { tag = 'button', isLink, href, target, text, className, ...rest } = button

                  const baseProps = {
                    tag,
                    text,
                    className,
                    ...rest,
                  }

                  if (isLink && href) {
                    return {
                      ...baseProps,
                      href,
                      target,
                      rel: target === '_blank' ? 'noreferrer' : undefined,
                      disposable: true,
                      onClick: () => closeModal('all'),
                    }
                  }

                  return {
                    ...baseProps,
                    disposable: true,
                    onClick: onButtonClick,
                  }
                }),
              },
            },
          ],
        },
      ],
    },
  }
}
